/**
 * Created by ys on 2018/4/3.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import sys from './modules/sys';
import user from './modules/user';
import getters from './getters';
Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    user,
    sys
  },
  getters
});
export default store



// WEBPACK FOOTER //
// ./src/store/index.js